export default "__VITE_ASSET__BfSenY2s__"